import { Badge as StageTenBadge } from "@lazarentertainment/web-design-system/components/badge"
import { ComponentPropsWithoutRef } from "react"

import styles from "./Badge.module.css"

export const badgeVariants = ["rose", "overlay", "neutral", "red"] as const

export const badgeSizes = ["sm", "md", "lg", "xl"] as const

export type BadgeProps = Omit<
  ComponentPropsWithoutRef<typeof StageTenBadge>,
  "variant" | "size"
> & {
  /**
   * Indicates the colour/variant of the Badge
   *
   * @default neutral
   */
  variant?: (typeof badgeVariants)[number]

  /**
   * Indicates the size of the Badge
   *
   * @default md
   */
  size?: (typeof badgeSizes)[number]
}

export const Badge = ({
  className,
  variant = "neutral",
  size = "md",
  ...props
}: BadgeProps) => {
  return (
    <StageTenBadge
      className={`${styles.badge} ${className}`}
      data-variant={variant}
      data-size={size}
      {...props}
    />
  )
}
